/**
 * Snapshot de AFEs en localStorage["pmis.afesDefault"].
 * Cargado por seed.ts cuando la DB está vacía (sustituye a sampleAfes).
 * Mismo patrón que contratosDefault.
 */

import type { Afe } from "@app-types/entities";

const STORAGE_KEY_DEFAULT = "pmis.afesDefault";

export function leerAfesDefault(): Afe[] | null {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY_DEFAULT);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return null;
    const ok = parsed.every(
      (a) =>
        a !== null &&
        typeof a === "object" &&
        "id" in a &&
        typeof (a as { id: unknown }).id === "string",
    );
    if (!ok) return null;
    return parsed as Afe[];
  } catch {
    return null;
  }
}

export function guardarAfesComoDefault(afes: Afe[]): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(STORAGE_KEY_DEFAULT, JSON.stringify(afes));
}

export function borrarAfesDefault(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(STORAGE_KEY_DEFAULT);
}

export function existeAfesDefault(): boolean {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem(STORAGE_KEY_DEFAULT) !== null;
}
